export default __webpack_public_path__ + "static/media/horizontal-line.d4e913aa.svg";